import React from 'react'
import update from 'immutability-helper';

import { tenantBilling } from '../../core/controllers/TenantBilling';
import { modal } from '../../core/utilities/modal';

export default class TenantPayOption extends React.Component {
    constructor(props) {
        super(props);

        this.shouldUpdate = true;
    }

    componentDidMount() {
        var self = this;
        jQuery(".toggle-switch").bootstrapToggle(this.props.autoPay);
        // TODO figure out why onChange reactjs event does not trigger
        jQuery("#auto-pay").change(function(e){
            if(!self.shouldUpdate) {
                return;
            }
            const value = jQuery(e.target).prop('checked');
            const id = jQuery(e.target).attr('notification-type-id');
            tenantBilling.updateAutoPayOption(value, function() {
                self.props.reloadParent();
                modal.showInfo("AutoPay has been turned " + (value ? 'On' : 'Off'), "success", "top", "center");
            });
        });
    }

    componentWillUpdate(nextProps, nextState) {
        this.shouldUpdate = false;
        jQuery('#auto-pay').bootstrapToggle(nextProps.autoPay);
        this.shouldUpdate = true;
    }

    render(){
        return (
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label for="effective_date">Autopay</label>
                    <br/>
                    <input type="checkbox" class="toggle-switch" id="auto-pay" defaultChecked={this.props.autoPay} data-toggle="toggle" />
                </div>
            </div>
        </div>
        );
    }
};


// WEBPACK FOOTER //
// app/components/Billing/TenantPayOptions.jsx